import React, { useState } from 'react';
import './PriceToggle.css';

interface PriceToggleProps {
  isBrutto: boolean;
  onToggle: (isBrutto: boolean) => void;
}

const PriceToggle: React.FC<PriceToggleProps> = ({ isBrutto, onToggle }) => {
  const [showInfo, setShowInfo] = useState(false);

  return (
    <div className="price-toggle-container">
      <div className="price-toggle">
        <label className="toggle-label">
          <span className={!isBrutto ? 'active' : ''}>Netto</span>
          <div className="toggle-switch">
            <input
              type="checkbox"
              checked={isBrutto}
              onChange={(e) => onToggle(e.target.checked)}
            />
            <span className="toggle-slider"></span>
          </div>
          <span className={isBrutto ? 'active' : ''}>Brutto</span>
        </label>

        <button 
          className="info-button"
          onClick={() => setShowInfo(!showInfo)}
          title="Berechnungsformel anzeigen"
        >
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
            <path d="M12 16v-4M12 8h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      </div>

      {showInfo && (
        <div className="price-info-popup">
          <div className="price-info-content">
            <button 
              className="close-button"
              onClick={() => setShowInfo(false)}
            >
              ×
            </button>
            <h3>Bruttostrompreis Berechnung</h3>
            <div className="formula">
              <div className="formula-line">
                <strong>Bruttostrompreis ≈</strong>
              </div>
              <ul>
                <li>Netto-Strompreis</li>
                <li>Tibber Beschaffungskosten: <small>0,72 ct/kWh</small></li>
                <li>Netzentgelt: <small>~10,9 ct/kWh</small></li>
                <li>Umlagen & Abgaben: <small>~2,65 ct/kWh</small></li>
                <li>MwSt: <small>19 %</small></li>
              </ul>
            </div>
            <p className="note">
              Die Bruttowerte sind Schätzungen basierend auf durchschnittlichen deutschen Haushaltstarifen.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default PriceToggle;